import http from "../http";

const dropDownList = {
    getWorkType(filters) {
        //工单类型下拉列表
        return http.get(`/work_order/workOrderTypes/getworkordertypelist`, {
            params: filters,
        });
    },
    getWorkCut() {
        //工单分类下拉列表
        return http.get(`/work_order/workOrderTypes/getworkorderparenttypelist`);
    },
    getWorkTypeNew(params) {
        return http.get(`/work_order/workOrderTypes/getQaTypeList`, {
            params,
        });
    },
    getWorkCutNew(params) {
        return http.get(`/work_order/workOrderTypes/getParentQaTypeList`);
    },
    getWorkTemplates(params) {
        return http.get(`/work_order/workOrderTypes/getQaTypeTemplate`, {params})
    }
};
export default dropDownList;
